export default "__VITE_ASSET__DCgr6$9a__"